'use strict';

if (typeof console === "undefined" || typeof console.log === "undefined") {
    console = {
        log: function() {}
    };
};